import { useEffect, useState } from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { type AuditEntry, getSuperadminApi, listAudit } from "@praesto/core";
import { Toolbar, Select } from "@praesto/ui-kit";

export function AuditTab() {
  // Same reasoning as the email log: the filter belongs in the URL, so a
  // filtered audit view can be linked and the back button undoes it.
  const search = useSearch({ strict: false }) as { action?: string };
  const navigate = useNavigate();
  const actionFilter = search.action ?? "";

  const [entries, setEntries] = useState<ReadonlyArray<AuditEntry>>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const api = getSuperadminApi();
      const tok = await api.getAuthToken();
      const r = await listAudit(api.apiBase, actionFilter ? { action: actionFilter } : {}, tok);
      if (!cancelled) setEntries(r.entries);
    })().catch((e) => {
      if (!cancelled) setError(String(e));
    });
    return () => {
      cancelled = true;
    };
  }, [actionFilter]);

  return (
    <div>
      <Toolbar
        title="Audit fleet-wide"
        actions={
          <Select
            size="sm"
            value={actionFilter}
            onChange={(e) =>
              void navigate({
                to: ".",
                search: e.target.value === "" ? {} : { action: e.target.value },
              } as never)
            }
          >
            <option value="">Tutte le azioni</option>
            <option value="superadmin.tenant.created">tenant.created</option>
            <option value="superadmin.tenant.disabled">tenant.disabled</option>
            <option value="superadmin.tenant.enabled">tenant.enabled</option>
            <option value="superadmin.impersonation.started">impersonation.started</option>
            <option value="superadmin.operator.invited">operator.invited</option>
            <option value="superadmin.emails.searched">emails.searched</option>
          </Select>
        }
      />
      {error && <p className="text-sm text-danger mb-3">{error}</p>}
      <ul className="space-y-1 text-mono-xs">
        {entries.map((e) => (
          <li key={e.id} className="border-b border-border-default py-1">
            <span className="text-fg-muted">{e.action}</span> · <strong>{e.actorEmail}</strong>
            {e.targetTenantId && ` → ${e.targetTenantId}`}
            {e.reason && ` · "${e.reason}"`}
          </li>
        ))}
      </ul>
    </div>
  );
}
